export default __webpack_public_path__ + "static/media/comm 4.291d1bf1.jpg";